module.exports = __webpack_public_path__ + "static/img/iha-logo.a174580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/web/assets/iha-logo.jpg
// module id = 106
// module chunks = 0